module.exports = __webpack_public_path__ + "2ac3885d6737ebd79914705e29d97b4e.png";